var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board-header"},[_c('logo',{staticClass:"logo-instance"}),_c('span',{staticClass:"page-title"},[_vm._v("\n    "+_vm._s(_vm.pageTitle)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }